<template>
  <card-component v-bind:title="setTitle(indexShowed)" icon="ballot">

    <b-field label="Nombre del Header" horizontal>
      <b-input v-model="nameHeaderShowed" maxlength="255" required/>
    </b-field>

    <b-field label="Premisa" horizontal>
      <b-input v-model="premiseShowed" maxlength="255" required/>
    </b-field>

    <b-field label="Tipo de Respuesta" horizontal>
      <b-select
        placeholder="Seleccionar tipo"
        v-model="typeSelected"
        rounded>
        <option
          v-for="type in allTypesAnswer"
          :value="type.value"
          :key="type.key">
          {{ type.key }}
        </option>
       </b-select>
     </b-field>
    <hr>
    <div v-if="isNew">
      <b-field horizontal>
        <div class="control">
          <b-button class="button-secondary" v-on:click="createItem()">
            Crear Pregunta
          </b-button>
        </div>
      </b-field>
    </div>
    <div v-else>
      <b-field horizontal>
        <div class="control">
          <b-button type="is-primary" v-on:click="updateItem()">
            Guardar
          </b-button>
        </div>
        <div class="control">
          <b-button v-on:click="deleteItem()" type="is-danger">
            Eliminar
          </b-button>
        </div>
      </b-field>
    </div>
    <b-loading :is-full-page="false" :active.sync="isLoading"/>
  </card-component>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import QuestionRepository from '@/services/QuestionRepository'
export default {
  name: 'QuestionItem',
  props: {
    index: {
      type: Number,
      default: 0
    },
    newItem: {
      type: Boolean,
      default: false
    },
    premise: {
      type: String,
      default: ''
    },
    nameHeader: {
      type: String,
      default: ''
    },
    typeAnswer: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0
    },
    allTypesAnswer: {
      type: Array,
      default: null
    }
  },
  components: {
    CardComponent
  },
  data () {
    return {
      premiseShowed: this.premise,
      indexShowed: this.index,
      typeSelected: this.typeAnswer,
      isNew: this.newItem,
      mID: this.id,
      nameHeaderShowed: this.nameHeader,
      isLoading: false
    }
  },
  methods: {
    deleteItem () {
      this.isLoading = true
      if (this.new) {
        this.$buefy.toast.open({
          message: 'Error: Esta pregunta aún no ha sido creada',
          type: 'is-info'
        })
        return
      }
      QuestionRepository.deleteQuestionResponse(this.mID)
        .then((r) => {
          location.reload()
        }).catch(e => {
          this.isLoading = false
          this.$buefy.toast.open({
            message: `Error: ${e.message}`,
            type: 'is-danger'
          })
        })
    },
    getItemInfoForm () {
      return {
        name_header: this.nameHeaderShowed,
        premise: this.premiseShowed,
        type_answer: this.typeSelected
      }
    },
    createItem () {
      this.isLoading = true
      QuestionRepository.createQuestionResponse(
        this.getItemInfoForm()
      ).then((r) => {
        this.isLoading = false
        this.$buefy.toast.open({
          message: 'Pregunta Creada',
          type: 'is-success'
        })
        this.isNew = false
        this.mID = r.data.id
      }).catch(e => {
        this.showErrorMessage(e)
      })
    },
    updateItem () {
      this.isLoading = true
      QuestionRepository.updateQuestionsResponses(
        this.mID,
        this.getItemInfoForm()
      ).then((r) => {
        this.isLoading = false
        this.$buefy.toast.open({
          message: 'Pregunta Actualizada',
          type: 'is-success'
        })
      }).catch(e => {
        this.showErrorMessage(e)
      })
    },
    setTitle (index) {
      if (this.isNew) return 'Nueva Pregunta'
      else return 'Pregunta ' + (index + 1)
    },
    showErrorMessage (e) {
      this.isLoading = false
      let message = e.message
      if (e.response.status === 400) {
        message = 'Ya existe una pregunta con ese HEADER'
      }
      this.$buefy.toast.open({
        message: `Error: ${message}`,
        type: 'is-danger'
      })
    }
  }
}
</script>
